import FilterForm from "../../../component/FilterForm/FilterForm";
import React, {useState} from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import {ApiUrl} from "../../../auth/authMethods";
import SelectInput from "../../../component/SelectInput";

export default function FilterWriteOff({filter, setFilter, setLoadData, setPage, initialFilter}) {

    const [lgShow, setLgShow] = useState(false);
    const [initDate, setInitDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [numeroLote, setNumeroLote] = useState('');
    const [numeroParcela, setNumeroParcela] = useState('');
    const [eventoList, setEventoList] = useState([])
    const [eventoId, setEventoId] = useState('');

    const handlesSubmit = (e) => {

        e.preventDefault();
        let filterData = initialFilter
        if (eventoId)
            filterData.eventoId = eventoId
        if (numeroLote)
            filterData.numeroLote = numeroLote
        if (numeroParcela)
            filterData.numeroParcela = numeroParcela
        if (initDate)
            filterData.initDate = initDate + 'T00:00:00'
        if (endDate)
            filterData.endDate = endDate + 'T23:59:59'

        console.log(filterData)
        setFilter(filterData);
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const clearFilter = () => {
        setEventoId('')
        setNumeroLote('')
        setNumeroParcela('')
        setInitDate('')
        setEndDate('')
        setFilter(initialFilter);
        setLgShow(false);
        setLoadData(true);
        setPage(0);
    }

    const InputLabelProps = {
        style: {
            zIndex: 0
        },
    }


    return <>
        <FilterForm
            handleSubmit={handlesSubmit} clearFilter={clearFilter}
            lgShow={lgShow} setLgShow={setLgShow}
            showSecondaryButton={Object.keys(filter).length !== 1}
        >

            <SelectInput
                url={ApiUrl + '/evento/list?status=ABERTO&size=20000'}
                list={eventoList}
                set={setEventoList}
                defaultValue={eventoId}
                setObj={setEventoId}
                returnList={() => {
                    let returnList = []
                    eventoList.forEach((item) => {
                        returnList.push({value: item.id, label: `${item.nomeEvento}`})
                    })
                    return returnList
                }}
                placeholder={"Evento"}
                isClearable={true}
                fullWidth

            />

            <TextField
                label="Número do Lote"
                inputProps={{
                    maxLength: 90
                }}
                value={numeroLote}
                onChange={(e) => {
                    setNumeroLote(e.target.value)
                }}
                fullWidth
                InputLabelProps={InputLabelProps}
            />

            <TextField
                label="Número da Parcela"
                inputProps={{
                    maxLength: 40
                }}
                value={numeroParcela}
                onChange={(e) => {
                    setNumeroParcela(e.target.value)
                }}
                fullWidth
                InputLabelProps={InputLabelProps}
            />

            <Box mb={0.5} pb={0.5}>
                Data de Vencimento
            </Box>
            <TextField
                label="Inicio"
                type="date"
                onChange={(e) => setInitDate(e.target.value)}
                value={initDate}
                size="large"
                InputLabelProps={{
                    style: {
                        background: 'white',
                        width: '50%',
                        textAlign: 'left',
                        zIndex: 1
                    }
                }}
                inputProps={{
                    min: "2000-01-01",
                    max: "2100-12-31",
                    style: {
                        zIndex: 0
                    }
                }}
                sx={{width: '49%', marginRight: '2%'}}
            />
            <TextField
                label="Fim"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                value={endDate}
                size="large"
                InputLabelProps={{
                    style: {
                        background: 'white',
                        width: '50%',
                        textAlign: 'left',
                        zIndex: 1
                    }
                }}
                inputProps={{
                    min: "2000-01-01",
                    max: "2100-12-31",
                    style: {
                        zIndex: 0
                    }
                }}
                sx={{width: '49%'}}
            />

        </FilterForm>
    </>
}